<template>
	<el-dialog :visible.sync="visible" :title="$t('nat.text.addDnatRule')" :close-on-click-modal="false"
		:before-close="handleClose" class="add-dnat-rule-dialog">
		<el-form ref="form" label-width="130px" :rules="rules" :model="form">
			<!-- NAT网关 -->
			<el-form-item :label="$t('nat.text.nat') | withColon">
				<span>{{ natInfo.name | maybeEmpty }}</span>
			</el-form-item>
			<!-- 端口类型 -->
			<el-form-item :label="$t('nat.text.portType') | withColon" required>
				<el-radio-group v-model="form.portType" @change="portTypeChange">
					<el-radio v-for="(item, index) in DnatPortTypeConstant" :label="item.value" :key="index">{{
						item.label }}</el-radio>
				</el-radio-group>
			</el-form-item>
			<!-- 支持协议 -->
			<el-form-item :label="$t('nat.text.supportProtocol') | withColon" required>
				<el-radio-group v-model="form.protocol" v-if="form.portType !== 'IP'">
					<el-radio v-for="(item, index) in DnatProtocolConstant" :label="item.value" :key="index">{{
						item.label }}</el-radio>
				</el-radio-group>
				<span v-else>ANY</span>
			</el-form-item>
			<!--弹性公网ip-->
			<el-form-item :label="$t('eip.text.eip') | withColon" required>
				<el-select style="width: 50%;" v-model="form.eipId" :no-data-text="$t('nat.placeholder.notEip')"
					:placeholder="$t('nat.placeholder.eip')" @visible-change="value => getEipList(value)"
					@change="value => changeEip(value)">
					<el-option v-for="item in eips" :key="item.eipId" :label="item.eip" :value="item.eipId">
					</el-option>
				</el-select>
			</el-form-item>
			<!--公网端口-->
			<el-form-item :label="$t('nat.text.publicNetPort') | withColon" required prop="eipPort" :show-message="false">
				<el-input style="width: 50%;" v-model="form.eipPort" v-if="form.portType !== 'IP'"></el-input>
				<span v-else>ANY</span>
				<p class="el-form-item-help" v-if="formTag.eipPort === ValidOrErrorConstant.ERROR"
					:class="{ 'el-form-item-help-error': formTag.eipPort === ValidOrErrorConstant.ERROR }">
					{{ $t('slb.sentence.port') }}
				</p>
			</el-form-item>
			<!--内网IP-->
			<el-form-item :label="$t('nat.text.priIpv4') | withColon" required>
				<el-select style="width: 50%;" v-model="form.privateIp" filterable popper-class="ip-address-select"
					:no-data-text="$t('nat.placeholder.emptyInstance')" :placeholder="$t('nat.placeholder.snatIp')"
					@visible-change="value => getCnatPrivateIps(value)" @change="value => changeCnatPrivateIp(value)">
					<el-option v-for="item in cnatPrivateIps" :key="item.privateIp" :label="item.text"
						:value="item.privateIp">
					</el-option>
				</el-select>
			</el-form-item>
			<!--内网端口-->
			<el-form-item :label="$t('nat.text.privatePort') | withColon" required prop="privatePort" :show-message="false">
				<el-input style="width: 50%;" v-model="form.privatePort" v-if="form.portType !== 'IP'"></el-input>
				<span v-else>ANY</span>
				<p class="el-form-item-help" v-if="formTag.privatePort === ValidOrErrorConstant.ERROR"
					:class="{ 'el-form-item-help-error': formTag.privatePort === ValidOrErrorConstant.ERROR }">
					{{ $t('slb.sentence.port') }}
				</p>
			</el-form-item>
			<!--描述-->
			<el-form-item :label="$t('create.text.desc') | withColon" prop="desc" :show-message="false" ref="desc">
				<el-input type="textarea" :rows="4" style="width: 50%;" v-model="form.desc"></el-input>
				<p class="el-form-item-name-help" :class="{ 'el-form-item-help-error': this.formTag.desc == 'error' }">
					{{ $t('create.help.desc') }}</p>
			</el-form-item>
		</el-form>
		<div slot="footer">
			<el-button @click="cancelBind">
				{{ $t('privateNetInstance.cancel') }}
			</el-button>
			<el-button @click="sureBind" type="primary" :disabled="isConfirmDisabled" :loading="sureBtnLoading">
				{{ $t('privateNetInstance.bindSure') }}
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
import {
	DnatPortTypeConstant,
	DnatProtocolConstant,
	NatRuleConstant,
	ValidOrErrorConstant
} from '@/common/Constants';
import { getNatPrivateIpsApi, getNatEipsApi, createDNatRuleApi } from '@/api/nat/detail/actions';
import * as BM from "@/common/bare-metal";
import { Loading } from '@jdcloud/jelement-next';
export default {
	name: 'AddDnatRule',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		natInfo: {
			type: Object,
			default: {}
		}
	},
	data() {
		this.DnatPortTypeConstant = DnatPortTypeConstant;
		this.DnatProtocolConstant = DnatProtocolConstant;
		this.ValidOrErrorConstant = ValidOrErrorConstant;
		// 校验公网端口是否在指定范围内
		const validateEipPort = (rule, value, callback) => {
			if (value > 65535 || value < 1) {
				this.formTag.eipPort = ValidOrErrorConstant.ERROR;
				callback(new Error());
			} else {
				this.formTag.eipPort = ValidOrErrorConstant.VALID;
				callback();
			}
		};
		// 校验内网端口是否在指定范围内
		const validatePrivatePort = (rule, value, callback) => {
			if (value > 65535 || value < 1) {
				this.formTag.privatePort = ValidOrErrorConstant.ERROR;
				callback(new Error());
			} else {
				this.formTag.privatePort = ValidOrErrorConstant.VALID;
				callback();
			}
		};
		const validateLength = (rule, value, callback) => {
			if (this.form.desc.length > 256) {
				callback(new Error());
			} else {
				callback();
			}
		};
		return {
			form: {
				portType: 'IP',
				eipPort: '',
				protocol: 'TCP',
				privateIp: '',
				privatePort: '',
				desc: "",
			},
			formTag: {
				desc: 0,
				eipPort: ValidOrErrorConstant.VALID,
				privatePort: ValidOrErrorConstant.VALID,
			},
			rules: {
				desc: [
					{ type: 'string', validator: validateLength, trigger: 'blur' }
				],
				eipPort: [
					{ required: true, validator: validateEipPort, trigger: 'blur' }
				],
				privatePort: [
					{ required: true, validator: validatePrivatePort, trigger: 'blur' }
				],
			},
			cnatPrivateIps: [],
			eips: [],
            sureBtnLoading: false,
		};
	},
	computed: {
		// 确定按钮是否置灰
		isConfirmDisabled: function () {
			if (this.form.portType === 'IP') {
				return !this.form.eipId || !this.form.privateIp;
			} else if (this.form.portType === 'PORT') {
				return !this.form.eipId || !this.form.privateIp || !this.form.eipPort || !this.form.privatePort || this.formTag.eipPort === 'error' || this.formTag.privatePort === 'error'
			}
		},
	},
	watch: {
		// 公网端口
		'form.eipPort': function (curVal) {
			if (!curVal) {
				this.form.privatePort = ''
				return false
			}
			// 实时把非数字的输入过滤掉
			this.form.eipPort = BM.filterNum(curVal);
		},
		// 内网端口
		'form.privatePort': function (curVal) {
			if (!curVal) {
				this.form.privatePort = ''
				return false
			}
			// 实时把非数字的输入过滤掉
			this.form.privatePort = BM.filterNum(curVal);
		},
	},
	created() {
	},
	methods: {
        portTypeChange() {
            this.form.privatePort = '';
            this.form.eipPort = '';
            this.form.protocol = '';

            this.formTag.desc = 0;
            this.formTag.eipPort = ValidOrErrorConstant.VALID;
            this.formTag.privatePort = ValidOrErrorConstant.VALID;
        },
		handleClose() {
            this.sureBtnLoading = false;
			this.resetDnatRule();
			this.$emit('update:visible', false);
		},
		cancelBind() {
			this.handleClose();
		},
		sureBind() {
            this.sureBtnLoading = true;
			const params = {
				region: this.natInfo.region,
				clientToken: Normal.getClientToken(),
				portType: this.form.portType,
				natGatewayId: this.natInfo.natGatewayId,
				eipId: this.form.eipId,
				protocol: this.form.portType === 'IP' ? 'ANY' : this.form.protocol,
				description: this.form.desc,
				eipPort: this.form.portType === 'IP' ? 'ANY' : this.form.eipPort,
				privatePort: this.form.portType === 'IP' ? 'ANY' : this.form.privatePort,
			};
			let privateIpInfo = this.cnatPrivateIps.filter(item => item.privateIp === this.form.privateIp).reduce((obj, current) => {
				obj.instanceId = current.instanceId;
				obj.isAliasIp = current.isAliasIp;
				obj.privateIp = current.privateIp;
				obj.subnetId = current.subnetId;
				return obj
			}, {});
			const realParams = Object.assign(params, privateIpInfo)
			createDNatRuleApi(realParams).then((res) => {
				this.$message.success(this.$t('privateNetInstance.operateSuccess'));
                this.handleClose();
                this.$emit('refresh');
			})
				.catch(async (err) => {
                    this.sureBtnLoading = false;
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
					// this.handleClose();
					// this.$emit('refresh');
				});
		},

		getCnatPrivateIps(visible) {
			if (!visible) {
				return
			}
			const params = {
				natGatewayId: this.natInfo.natGatewayId,
				region: this.natInfo.region,
				portType: this.form.portType,
				service: NatRuleConstant.DNAT
			};
			getNatPrivateIpsApi(params).then((res) => {
				if (res.errno === 10000 && res.data) {
					this.cnatPrivateIps = res.data.cnatPrivateIps.map(item => {
						item.ipText = item.isAliasIp ? this.$t('ipv6.text.aliasip') : this.$t('ipv6.text.rip');
						item.text = `${item.privateIp}(${item.ipText})`;
						return item
					});
				}
			}).finally(() => {
			});
		},

		changeCnatPrivateIp(value) {
		},

		getEipList(visible) {
			if (!visible) {
				return
			}
			const params = {
				region: this.natInfo.region,
				natGatewayId: this.natInfo.natGatewayId,
				portType: this.form.portType,
				service: NatRuleConstant.DNAT
			};
			getNatEipsApi(params).then((res) => {
				if (res.errno === 10000 && res.data) {
					this.eips = res.data.cnatEIPList.map(item => {
						return item
					});
				}
			}).finally(() => {
			});
		},

		changeEip(value) {

		},

		resetDnatRule() {
			this.form = {
				portType: 'IP',
				eipPort: '',
				protocol: 'TCP',
				privateIp: '',
				privatePort: '',
				desc: "",
			};
			this.formTag = {
				desc: 0,
				eipPort: ValidOrErrorConstant.VALID,
				privatePort: ValidOrErrorConstant.VALID,
			};
		}
	},
};
</script>

<style lang="scss">
.add-dnat-rule-dialog {
    .el-form-item .el-form-item-help {
        padding-bottom: 0 !important;
    }
    .el-form-item__error {
        padding-bottom: 0 !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/nat/AddDnatRule.vue